// store/modules/toastr.js
const ADD = 'ADD_TOAST';
const REMOVE = 'REMOVE_TOAST';

export default {
	namespaced: true,
	state: {
		items: []
	},
	mutations: {
		[ADD](state, payload) {
			if (!state.items.some(toast => toast.id === payload.id)) {
				state.items.push(payload);
			}
		},
		[REMOVE](state, id) {
			state.items = state.items.filter(toast => toast.id !== id);
		}
	},
	actions: {
		addToastr({ commit }, payload) {
			commit(ADD, payload);
		},
		removeToastr({ commit }, id) {
			commit(REMOVE, id);
		}
	}
};
